import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=vintage%20cinema%20projector%20in%20dark%20room%20with%20warm%20golden%20film%20reel%20light%2C%20classic%20movie%20theater%20atmosphere%2C%20elegant%20curtains%2C%20academic%20film%20studies%20library%20background%2C%20soft%20dramatic%20lighting%2C%20rich%20amber%20and%20gold%20tones%2C%20cinematic%20composition&width=1800&height=900&seq=hero-film-research&orientation=landscape"
        alt="电影分级研究"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-semibold text-white mb-4 leading-tight">
            三级片分级制度与文化研究
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            系统梳理香港、台湾及亚洲电影分级制度的历史起源、审查标准与文化背景，为电影研究者与爱好者提供权威学术知识平台。
          </p>
          <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
            <Link
              to="/category/grading-system"
              className="px-6 py-3 bg-primary-500 text-white rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              探索分级制度
            </Link>
            <Link
              to="/category/representative-works"
              className="px-6 py-3 bg-white/15 text-white border border-white/30 rounded-md font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览代表作品
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}